import React, { memo } from 'react';
import { SidebarBoundary } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-common-core/src/ui/sidebar-boundary/index.tsx';
import type { JcsProjectMenuProps } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-content-projects-jcs-project-menu/src/ui/project-menu/JcsProjectMenu.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import { SkeletonNavMenuItems } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-common-core/src/common/ui/skeleton-nav-menu-items/main.tsx';

const Skeleton = () => <SkeletonNavMenuItems count={1} />;

const LazySidebarContent = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "async-jira-navigation-apps-sidebar-nav4-sidebar-jcs-project-menu" */ './ui/project-menu/JcsProjectMenu'
		).then(({ JcsProjectMenu }) => JcsProjectMenu),
	{
		includeInShellOnlySsrBundle: true,
		entryFsSsrLiftImportToModule: true,
	},
);

export const AsyncJcsProjectMenu = memo(
	({ projectData, spotlight, menuItemButtonRef }: JcsProjectMenuProps) => (
		<SidebarBoundary
			id="nav4.sidebar.jcs-project-menu"
			packageName="jiraNavigationAppsSidebarNav4JcsProjectMenu"
			teamName="Boysenberry"
			ufoName="nav4.sidebar.jcs-project-menu"
		>
			<Placeholder name="nav4.sidebar.jcs-project-menu.loading-lazy" fallback={<Skeleton />}>
				<LazySidebarContent
					projectData={projectData}
					spotlight={spotlight}
					menuItemButtonRef={menuItemButtonRef}
				/>
			</Placeholder>
		</SidebarBoundary>
	),
);
